module.exports = __webpack_public_path__ + "img/TS_ICON_CHAPTERS.bb1ac43e.png";